import styled from "styled-components";

// ASCP·A1 TCMS 화면과 기술 소개 페이지 하단의 저작권·특허 고지
const CopyrightNote = () => (
  <Note>
    본 페이지의 화면 이미지와 시스템 구성은 관세법인 에이원의 저작물이며, 무단 복제·배포·사용을 금합니다.
    <br />
    HS CODE 품목분류 정보 제공 시스템 특허 출원 제10-2024-0155229호
  </Note>
);
export default CopyrightNote;

const Note = styled.div`
  margin-top: 3rem;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.colors.monotone.light};
  font-size: 0.85em;
  line-height: 1.7em;
  color: ${({ theme }) => theme.colors.foreground.dimmed};
  text-align: center;
`;
